<template>
  <div class="social-actions">
  </div>
</template>

<script setup>
/**
 * 実装未定
 * 
 * SNSへの投稿用
 */
</script>

<style lang="scss">
</style>
